<script setup>
import { computed, onMounted } from 'vue'
import store from '@/store'
import ModalLayout from '@/components/Modals/ModalBase'
import BaseButton from '@/components/Base/Button/BaseButton'
import { handleBackButton } from '@/utils'

const confirmData = computed(() => {
  return store.getters.modalData
})

const confirmAction = () => {
  store.dispatch('ConfirmAction')
}

const cancelAction = () => {
  store.dispatch('CancelAction')
}

const isDelete = (text) => {
  return text.toLowerCase() === 'delete'
}

onMounted(() => {
  handleBackButton()
})
</script>

<template>
  <modal-layout modal-class="bg-white modal-delete" :is-close="true">
    <template #modal-title>
      <span class="modal-delete-header">
        <h1 class="modal-delete-title">
          {{ confirmData?.data?.title }}
        </h1>
      </span>
    </template>
    <template #modal-subContent>
      <span class="modal-delete-body">
        <p class="modal-delete-content">
          {{ confirmData?.data?.description }}
        </p>
      </span>
    </template>

    <!-- Back to Events & Submit Buttons -->
    <template #modal-button>
      <span class="modal-delete-btn-container">
          <base-button :functions="cancelAction"
                       :text="confirmData?.data?.cancelButton"
                       class-name="modal-delete-btn modal-delete-btn-back"
                        btn-type="secondary"/>
          <base-button :functions="confirmAction"
                       :text="confirmData?.data?.confirmButton"
                       :class-name="`modal-delete-btn ${isDelete(confirmData?.data?.confirmButton) ?
                        'modal-delete-btn-delete' : 'modal-delete-btn-approve' }`"
                        btn-type="primary"/>
        </span>
    </template>
  </modal-layout>
</template>

<style lang="scss" scoped>
.modal {
  &-delete {
    @apply md:h-auto overflow-y-auto max-w-md md:p-7 p-4 rounded-b-none md:rounded-2xl;
    &-header {
      @apply flex flex-col w-full justify-center items-center;
    }
    &-title {
      @apply normal-case font-medium text-h3 text-center text-blacks-500 pb-3 pl-12 pr-12;
    }
    &-body {
      @apply flex flex-col justify-center items-center;
    }
    &-content {
      @apply text-blacks-300 text-p-md text-center pl-12 pr-12;
    }
    &-btn {
      @apply w-[12rem] h-[3rem] mx-1 normal-case;
      &-container {
        @apply w-full flex flex-row justify-center mt-8;
      }
      &-back {
        @apply text-primary border-primary font-medium hover:border-transparent hover:bg-white hover:text-product-500;
      }
      &-approve {
        @apply bg-other-green text-white font-medium hover:opacity-80;
      }
      &-delete {
        @apply bg-other-red text-white font-medium hover:opacity-80;
      }
    }
  }
}
</style>
